import React from 'react';
import Input from '../Common/Input';
import Select from '../Common/Select';
import { useEffect } from 'react';

const Form = ({ formik }) => {

    useEffect(() => {
        console.log(formik.values);
    },[formik.values])

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="col-md-3">
                    <Input label="عنوان" name="title" required={true} formik={formik} />
                </div>
                <div className="col-md-4">
                    <Select label="این نقش مربوط به کسب و کار است ؟" name="businessEnable" required={true} formik={formik}>
                        <option value={0}>خیر</option>
                        <option value={1}>بله</option>
                    </Select>
                </div>
            </div>
            <button className="btn btn-success" id="btn-submit-form">ذخیره اطلاعات</button>
        </form>
    );
}

export default Form;